//********************** */
//* Global variables
//********************** */
// loading spinner Element
const $f8d8239ac9be2ae9$var$loadingElement = document.body.querySelector(".loading-container");
//*********************************************** */
//* Game board cells and keyboard Functions
//*********************************************** */
//********************* */
//* Main Functions
//********************* */
/*
  * cell animation function takes four arguments:
    ** rowCells => which is one cell or all cells (one cell for removing, all cells for adding or validating)
    ** keyValue => the value of the pressed key either on user keyboard or virtual one
    ** validationArray, keyboardButtons => only used in the enter key to 
    ** animate when validating in both game board cells and keyboard buttons
*/ function $f8d8239ac9be2ae9$export$2b30b4c5c46f02b8(rowCells, keyValue, validationArray, keyboardButtons) {
    // unify input
    keyValue = keyValue.toLowerCase();
    if (keyValue === "enter") {
        if (validationArray === undefined) $f8d8239ac9be2ae9$var$rejectionAnimation(rowCells);
        else $f8d8239ac9be2ae9$var$validationAnimation(rowCells, validationArray, keyboardButtons);
    } else if (keyValue === "backspace") {
        // rowCells is only 1 cell in this block, so it's more logical that the variable represents it's meaning
        const rowCell = rowCells;
        $f8d8239ac9be2ae9$var$animateAndRemove(rowCell);
    } else $f8d8239ac9be2ae9$var$addingAnimation(rowCells);
}
//********************* */
//* Helper Functions
//********************* */
/*
  * This function handles the animation of wrong input for the Enter key
    ** RowCells => the cells that the animation is applied to
*/ function $f8d8239ac9be2ae9$var$rejectionAnimation(rowCells) {
    // Get Cells Parent => (row)
    let row = rowCells[0].parentNode;
    // add row animation
    row.classList.add("row-rejection");
    // add cells animation
    for (let cell of rowCells)cell.classList.add("cell-rejection");
    // remove the row and cells animations after duration ends
    setTimeout(()=>{
        row.classList.remove("row-rejection");
        for (let cell of rowCells)cell.classList.remove("cell-rejection");
    }, 1000);
}
/*
  * This function handles the animation of valid input for the Enter key
    ** RowCells => the cells that the animation is applied to
    ** validationArray => the array that determines how each cell will be changed (true => correct, "close" => close, false => missing)
    ** keyboardButtons => all keyboard buttons (to apply animation to corresponding buttons)
*/ function $f8d8239ac9be2ae9$var$validationAnimation(rowCells, validationArray, keyboardButtons) {
    // animation delay for each cell
    let animationDelay = 0.15;
    // for each value in validationArray
    for(let i = 0; i < validationArray.length; i++){
        // current cell in row
        let currentCell = rowCells[i];
        // find relative keyboard button in the on-screen keyboard
        let keyboardButton;
        for (let button of keyboardButtons)// toUpperCase is mostly unnecessary here but just for strict checking
        if (button.innerText.toUpperCase() === currentCell.innerText.toUpperCase()) keyboardButton = button;
        // current validation cell value
        let validationCell = validationArray[i];
        // get the current theme
        const currentTheme = document.querySelector(".switch__checkbox").getAttribute("data-theme");
        // animate current row cell and keyboard button
        currentCell.classList.add("game-board-validation");
        keyboardButton.classList.add("keyboard-validation");
        // give different delay between each cell and each keyboard button
        currentCell.style.animationDelay = `${i * animationDelay}s`;
        keyboardButton.style.animationDelay = `${i * animationDelay}s`;
        // after half of the animation time passes, add the validation relative colors
        setTimeout(()=>{
            // change cells and keyboard colors for visual feedback
            $f8d8239ac9be2ae9$var$handleValidationColors(currentCell, keyboardButton, validationCell, currentTheme);
        }, 500 + i * (animationDelay * 1000));
        // remove keyboard animation after finishing
        setTimeout(()=>{
            keyboardButton.classList.remove("keyboard-validation");
            keyboardButton.style.removeProperty("animation-delay");
        }, 1000 + i * (animationDelay * 1000));
    }
}
/*
  * This function adds the relative coloring class to current cell and current keyboard button
    ** based on the values of validationCell and currentTheme
*/ function $f8d8239ac9be2ae9$var$handleValidationColors(currentCell, currentKeyboardButton, validationCell, currentTheme) {
    // general cell and keyboard button classes
    const cellClass = "game-board__letter";
    const btnClass = "keyboard__letter";
    if (validationCell === true) {
        // correct state classes
        const correctCellClass = `${cellClass}--correct`;
        const correctBtnClass = `${btnClass}--correct`;
        // add default classes
        currentCell.classList.add(correctCellClass);
        currentKeyboardButton.classList.add(correctBtnClass);
        // check for dark theme and apply related classes if found
        if (currentTheme === "dark") {
            currentCell.classList.add(`${correctCellClass}-dark`);
            currentKeyboardButton.classList.add(`${correctBtnClass}-dark`);
        }
    } else if (validationCell === "close") {
        // close state classes
        const closeCellClass = `${cellClass}--close`;
        const closeBtnClass = `${btnClass}--close`;
        currentCell.classList.add(closeCellClass);
        currentKeyboardButton.classList.add(closeBtnClass);
        if (currentTheme === "dark") {
            currentCell.classList.add(`${closeCellClass}-dark`);
            currentKeyboardButton.classList.add(`${closeBtnClass}-dark`);
        }
    } else {
        // missing state classes
        const missingCellClass = `${cellClass}--missing`;
        const missingBtnClass = `${btnClass}--missing`;
        currentCell.classList.add(missingCellClass);
        currentKeyboardButton.classList.add(missingBtnClass);
        if (currentTheme === "dark") {
            currentCell.classList.add(`${missingCellClass}-dark`);
            currentKeyboardButton.classList.add(`${missingBtnClass}-dark`);
        }
    }
}
/*
  * This function takes as argument one cell, adds removal animation and removes it's content
    ** Just as specified in animateAndRemoveLetter function (input.mjs)
    ** this function handles both the input functionality and animation functionality
*/ function $f8d8239ac9be2ae9$var$animateAndRemove(rowCell) {
    // choose the cell span element
    let cellText = rowCell.querySelector(".letter-text");
    // add removing animation to span
    cellText.classList.add("letter-removing");
    // after animation ends
    setTimeout(()=>{
        // remove cell content
        cellText.innerText = "";
        // remove animation to allow for future animations
        cellText.classList.remove("letter-removing");
    }, 200);
}
//* Function to add the insertion animation on the last occupied cell
function $f8d8239ac9be2ae9$var$addingAnimation(rowCells) {
    // find last occupied cell
    let lastOccupiedCell;
    for (let cell of rowCells)if (cell.innerText !== "") lastOccupiedCell = cell;
    // choose cell span Element
    let cellText = lastOccupiedCell.querySelector(".letter-text");
    // add animations to the cell
    cellText.classList.add("letter-adding");
    // remove animations from the cell after animation ends
    setTimeout(()=>cellText.classList.remove("letter-adding"), 200);
}
//* Function to mimic validation animation for how to play dialog fake game row
function $f8d8239ac9be2ae9$export$8be79abfbbb1b7ab(rowCells) {
    let animationDelay = 150;
    for(let i = 0; i < rowCells.length; i++){
        // get current cell
        let currentCell = rowCells[i];
        // animate fake cell
        setTimeout(()=>{
            currentCell.classList.add("game-board-validation");
        }, 200 + i * animationDelay);
        // remove cell animation after finishing
        setTimeout(()=>{
            currentCell.classList.remove("game-board-validation");
        }, 1200 + i * animationDelay);
    }
}
/*
  * Function to handle keyboard animations on different keydown events
    ** backspace event
    ** enter
    ** other uppercase-lowercase letters
*/ function $f8d8239ac9be2ae9$export$5c4515537cbee0e0(keyboardButtons, keyValue) {
    // set initial variables
    let pressedButton;
    let keyLowerCased = keyValue.toLowerCase();
    // Get corresponding pressed button on keyboard
    if (keyLowerCased === "backspace") {
        //* if removing a letter
        // get backspace button
        pressedButton = document.querySelector(".backspace-button");
        // Add animation
        pressedButton.classList.add("backspace-typing");
    } else if (keyLowerCased === "enter") {
        //* if submitting a guess
        // get enter button
        pressedButton = document.querySelector(".enter-button");
        // Add animation
        pressedButton.classList.add("enter-typing");
    } else {
        //* for other buttons
        // find relative button on keyboard
        for (let button of keyboardButtons)//* button text lowercasing is unnecessary for most cases only for stricter checking
        if (button.innerHTML.toLowerCase() === keyLowerCased) {
            pressedButton = button;
            break;
        }
        // Add animation
        pressedButton.classList.add("letter-typing");
    }
    // for other keys (symbols, numbers...etc)
    if (pressedButton === undefined) {
        $f8d8239ac9be2ae9$var$fun();
        return;
    }
}
/*
  * Function to remove keyboard animations on keyup event
    ** the animation on each button is added once with keyboardAnimation function
    ** and removed only with key is released
*/ function $f8d8239ac9be2ae9$export$82f1d4313688e804(keyboardButtons, keyValue) {
    // Get pressed button and unify input
    let pressedButton;
    let keyLowerCased = keyValue.toLowerCase();
    // check cases
    if (keyLowerCased === "backspace") pressedButton = document.querySelector(".backspace-button");
    else if (keyLowerCased === "enter") pressedButton = document.querySelector(".enter-button");
    else {
        for (let button of keyboardButtons)if (button.innerHTML.toLowerCase() === keyLowerCased) {
            pressedButton = button;
            break;
        }
    }
    // if other buttons are pressed
    if (pressedButton === undefined) {
        $f8d8239ac9be2ae9$var$fun();
        return;
    }
    // remove after animation duration is complete
    setTimeout(()=>{
        if (pressedButton.classList.contains("backspace-typing")) pressedButton.classList.remove("backspace-typing");
        else if (pressedButton.classList.contains("enter-typing")) pressedButton.classList.remove("enter-typing");
        else if (pressedButton.classList.contains("letter-typing")) pressedButton.classList.remove("letter-typing");
    }, 150);
}
const $f8d8239ac9be2ae9$var$fun = ()=>{
    console.log(`Know what the button said to the clicker? 
~crying in sadness~ 
it just feels like, you're always pushing me away 😢`);
};
//************************************** */
//* Dialogs Functions
//************************************** */
//* Function that adds the entry animation to a dialog
function $f8d8239ac9be2ae9$export$21d6af064bc42dba(dialog) {
    dialog.classList.add("dialog-entry");
}
//* Function that adds the exit animation to a dialog and removes hanging animations classes
function $f8d8239ac9be2ae9$export$48363b365af47301(dialog) {
    dialog.classList.remove("dialog-entry");
    dialog.classList.add("dialog-exit");
    setTimeout(()=>{
        dialog.classList.remove("dialog-exit");
    }, 500);
}
//************************************** */
//* loading element Functions
//************************************** */
//* Function to show loading spinner element
function $f8d8239ac9be2ae9$export$64858b67578a10bb() {
    $f8d8239ac9be2ae9$var$loadingElement.style.visibility = "visible";
}
//* Function to hide loading spinner element
function $f8d8239ac9be2ae9$export$7d026bf51c574e0d() {
    $f8d8239ac9be2ae9$var$loadingElement.style.visibility = "hidden";
}


//********************* */
//* Main Functions
//********************* */
/*
  * all input functions returns true only if any change has been made
    ** eg. added a letter, removed a letter or pressed enter (has no effect, just for consistency sake)
*/ function $5ab19e18f0cc9b1e$export$412508d679148d5c(rowCells, key) {
    // unify input
    key = key.toLowerCase();
    // check cases
    if (key === "backspace") return $5ab19e18f0cc9b1e$var$animateAndRemoveLetter(rowCells);
    else if (key === "enter") return true;
    else if ($5ab19e18f0cc9b1e$var$isLetter(key)) return $5ab19e18f0cc9b1e$var$addLetter(rowCells, key); // add a letter
}
//********************* */
//* Helper Functions
//********************* */
/*
  * Function that animates the last occupied cell and then removes it's content
    ** this is the only function that applies a side effect in input functions
    ** due to the fact that the animation needs to be applied before removing the letter
*/ function $5ab19e18f0cc9b1e$var$animateAndRemoveLetter(rowCells) {
    // iterate backwards on row
    for(let i = rowCells.length - 1; i >= 0; i--)// find last occupied cell
    if (rowCells[i].innerText !== "") {
        // Add animation and remove cell content
        (0, $f8d8239ac9be2ae9$export$2b30b4c5c46f02b8)(rowCells[i], "backspace");
        break;
    }
    return true;
}
//* Function that adds a letter to the next empty cell in the current row
function $5ab19e18f0cc9b1e$var$addLetter(rowCells, keyValue) {
    // initial value for last empty cell
    let lastEmptyCell;
    // find last empty cell
    for (let cell of rowCells)if (cell.innerText === "") {
        // set last empty cell and break
        lastEmptyCell = cell;
        break;
    }
    // if all cells are occupied
    if (lastEmptyCell === undefined) return false;
    // get cell span element
    let emptyCellText = lastEmptyCell.childNodes[0];
    // add content to span
    emptyCellText.innerText = keyValue.toUpperCase();
    return true;
}
//* Function to check if a character is an uppercase or lowercase letter
const $5ab19e18f0cc9b1e$var$isLetter = (letter)=>{
    const regex = /^[a-zA-Z]$/;
    return regex.test(letter);
};








//********************* */
//* Global Variables
//********************* */
// track user progress
const $1cc9319a0b1861d3$export$7abfd4649f15e11f = {
    currentRow: 0,
    isSolved: false
};
const $1cc9319a0b1861d3$export$af20da7343c4b20b = JSON.parse($1cc9319a0b1861d3$export$ed608b63f17f3f82());
//****************************************************** */
//* Main Functions
//****************************************************** */
/*
  * Function that retrieves previous user progress or creates new one
    ** if first session or a new day => initiate a new userProgress object
    ** otherwise => get previous user progress object
*/ function $1cc9319a0b1861d3$export$ed608b63f17f3f82() {
    if (localStorage.getItem("userProgress") === null || (0, $d6cfc0aabef0aa82$export$c3e675fb255e6adf)()) return $1cc9319a0b1861d3$var$initUserProgress();
    else return localStorage.getItem("userProgress");
}
/*
  * This function saves the current user progress in the local storage
    ** Saves current row number
    ** Saves added cells text and classes
    ** Saves added keyboard buttons classes
    ** tracks if the game has been solved or not
*/ function $1cc9319a0b1861d3$export$384cd953322e3851(rowCells) {
    // save last finished row number
    $1cc9319a0b1861d3$export$af20da7343c4b20b.currentRow = $1cc9319a0b1861d3$export$7abfd4649f15e11f.currentRow;
    // save cells data
    $1cc9319a0b1861d3$var$saveCellsState(rowCells);
    // save keyboard data
    $1cc9319a0b1861d3$var$saveKeyboardState();
    // save if the user solved the puzzle
    if ($1cc9319a0b1861d3$export$7abfd4649f15e11f.isSolved) $1cc9319a0b1861d3$export$af20da7343c4b20b.isSolved = true;
    // push the new game state back to the local storage
    localStorage.setItem("userProgress", JSON.stringify($1cc9319a0b1861d3$export$af20da7343c4b20b));
}
//* This function applies last user session game state
async function $1cc9319a0b1861d3$export$70a369479cdf5432(previousGameState) {
    // set user current row
    $1cc9319a0b1861d3$export$7abfd4649f15e11f.currentRow = previousGameState.currentRow + 1;
    // set if the user solved the game or not
    $1cc9319a0b1861d3$export$7abfd4649f15e11f.isSolved = previousGameState.isSolved;
    // set cells to previous state (text - classes)
    $1cc9319a0b1861d3$var$setPreviousCellsState();
    // set keyboard button to previous state (classes)
    $1cc9319a0b1861d3$var$setPreviousKeyboardState();
    // if user lost at previous session
    if (previousGameState.currentRow === 5 && !previousGameState.isSolved) {
        // display correct word
        const todayWord = await (0, $d6cfc0aabef0aa82$export$a5bfddfac516cc04)();
        (0, $50a8fd1ed092fc9a$export$6ec214f034b61612)(`Correct word: ${todayWord.toUpperCase()}`, true);
    } else if (previousGameState.isSolved) {
        const positions = [
            "first",
            "second",
            "third",
            "fourth",
            "fifth",
            "sixth"
        ];
        (0, $50a8fd1ed092fc9a$export$6ec214f034b61612)(`Excellent work!, You solved today's word in the ${positions[previousGameState.currentRow]} row`, true);
    }
}
/*
  * This function removes last user session game state
*/ function $1cc9319a0b1861d3$export$2dc65a8d5a607c9a() {
    localStorage.removeItem("userProgress");
}
//****************************************************** */
//* Helper Functions
//****************************************************** */
//* this function initiates a user progress Object in the local storage and returns it
function $1cc9319a0b1861d3$var$initUserProgress() {
    // initialize initial variables
    const totalRows = 6;
    const totalRowCells = 5;
    const totalKeyboardBtns = 26;
    const [rowsData, rowsClasses, keyboardBtnsClasses] = [
        [],
        [],
        []
    ];
    // for each row
    for(let i = 0; i < totalRows; i++){
        // set initial cells text data
        rowsData[i] = Array(totalRowCells).fill("");
        // set initial cells applied classes
        rowsClasses[i] = Array(totalRowCells).fill("");
    }
    // for each keyboard button
    const allButtons = document.querySelectorAll(".keyboard__letter:not(.enter-button):not(.backspace-button)");
    // set buttons classes initial values
    for(let i = 0; i < totalKeyboardBtns; i++)keyboardBtnsClasses[i] = [
        allButtons[i].innerText,
        ""
    ];
    /*
    * currentRow => the guess row the user is currently at
    * rowsData => the text data for each cell, with a total of five cells for each row
    * rowsClasses => the applied class for each cell on each row
    * keyboardClasses => the applied class for each keyboard button
    * isSolved => boolean indicating whether the word is solved or not
  */ localStorage.setItem("userProgress", JSON.stringify({
        currentRow: -1,
        rowsData: rowsData,
        rowsClasses: rowsClasses,
        keyboardClasses: keyboardBtnsClasses,
        isSolved: false
    }));
    return localStorage.getItem("userProgress");
}
//* Helper function to set previous cells state (text - classes)
function $1cc9319a0b1861d3$var$setPreviousCellsState() {
    // set completed rows data and classes to previous game state
    // get all rows
    const allRows = document.querySelectorAll(".game-board__row");
    for(let i = 0; i <= $1cc9319a0b1861d3$export$af20da7343c4b20b.currentRow; i++){
        // get current completed row and his children (cells)
        const currentRow = allRows[i];
        const rowChildren = currentRow.children;
        // mark as done
        currentRow.setAttribute("data-state", "DONE");
        // for each cell 
        for(let j = 0; j < rowChildren.length; j++){
            // get current cell and it's span
            const currentCell = rowChildren[j];
            const currentCellSpan = currentCell.childNodes[0];
            // add cell text from previous session to current cell
            currentCellSpan.innerText = $1cc9319a0b1861d3$export$af20da7343c4b20b.rowsData[i][j];
            // get the cell class used in the previous session
            const correspondingCellClass = $1cc9319a0b1861d3$export$af20da7343c4b20b.rowsClasses[i][j];
            // apply the validation animation to cell
            currentCell.classList.add("game-board-validation");
            // add animation duration
            currentCell.style.animationDelay = `${i * 0.03}s`;
            // add the color class to the cell
            currentCell.classList.add(correspondingCellClass);
        }
    }
}
//* Helper function to set previous keyboard state (classes)
function $1cc9319a0b1861d3$var$setPreviousKeyboardState() {
    // Get all buttons (without enter and backspace buttons)
    const allButtons = document.querySelectorAll(".keyboard__letter:not(.enter-button):not(.backspace-button)");
    // iterate over each button
    for(let i = 0; i < allButtons.length; i++){
        const currentBtn = allButtons[i];
        // get corresponding previous class for the current button
        const btnPreviousClass = $1cc9319a0b1861d3$export$af20da7343c4b20b.keyboardClasses[i][1];
        // if button has been chosen in previous session
        if (btnPreviousClass !== "") {
            // apply the validation animation to cell
            currentBtn.classList.add("keyboard-validation");
            // add animation duration
            currentBtn.style.animationDelay = `${i * 0.03}s`;
            // add the color class to the cell
            currentBtn.classList.add(btnPreviousClass);
            // remove animation and delay for future animations
            setTimeout(()=>{
                currentBtn.classList.remove("keyboard-validation");
                currentBtn.style.removeProperty("animation-delay");
            }, 1000 + i * 30);
        }
    }
}
//* Function to save current Cells text and classes after each validation 
function $1cc9319a0b1861d3$var$saveCellsState(rowCells) {
    //* save cells text and classes data
    const totalRowCells = 5;
    // for each row cell
    for(let i = 0; i < totalRowCells; i++){
        // for each cell in the current row add the corresponding cell text
        $1cc9319a0b1861d3$export$af20da7343c4b20b.rowsData[$1cc9319a0b1861d3$export$af20da7343c4b20b.currentRow][i] = rowCells[i].childNodes[0].innerText;
        // save the corresponding cells Classes
        const cellClasses = rowCells[i].classList;
        const cellClassGenre = "game-board__letter--";
        if (cellClasses.contains(`${cellClassGenre}correct`)) $1cc9319a0b1861d3$export$af20da7343c4b20b.rowsClasses[$1cc9319a0b1861d3$export$af20da7343c4b20b.currentRow][i] = `${cellClassGenre}correct`;
        else if (cellClasses.contains(`${cellClassGenre}close`)) $1cc9319a0b1861d3$export$af20da7343c4b20b.rowsClasses[$1cc9319a0b1861d3$export$af20da7343c4b20b.currentRow][i] = `${cellClassGenre}close`;
        else if (cellClasses.contains(`${cellClassGenre}missing`)) $1cc9319a0b1861d3$export$af20da7343c4b20b.rowsClasses[$1cc9319a0b1861d3$export$af20da7343c4b20b.currentRow][i] = `${cellClassGenre}missing`;
    }
}
//* Function that saves keyboard buttons added classes after each validation
function $1cc9319a0b1861d3$var$saveKeyboardState() {
    // total keyboard buttons (without enter and backspace)
    const totalKeyboardBtns = 26;
    const keyboardBtns = document.querySelectorAll(".keyboard__letter:not(.enter-button):not(.backspace-button)");
    // save the corresponding keyboard buttons classes
    const keyboardClassGenre = "keyboard__letter--";
    // add the keyboard buttons classes
    for(let i = 0; i < totalKeyboardBtns; i++){
        const currentBtnClasses = keyboardBtns[i].classList;
        if (currentBtnClasses.contains(`${keyboardClassGenre}correct`)) $1cc9319a0b1861d3$export$af20da7343c4b20b.keyboardClasses[i][1] = `${keyboardClassGenre}correct`;
        else if (currentBtnClasses.contains(`${keyboardClassGenre}close`)) $1cc9319a0b1861d3$export$af20da7343c4b20b.keyboardClasses[i][1] = `${keyboardClassGenre}close`;
        else if (currentBtnClasses.contains(`${keyboardClassGenre}missing`)) $1cc9319a0b1861d3$export$af20da7343c4b20b.keyboardClasses[i][1] = `${keyboardClassGenre}missing`;
    }
}


//********************* */
//* Global Variables
//********************* */
//* settings and howToPlay dialogs
const $e68b6f26e5e2e4f1$var$settingsDialog = document.querySelector(".settings-dialog");
const $e68b6f26e5e2e4f1$var$howToPlayDialog = document.querySelector(".how-to-play-dialog");
//* dark mode switch and checkbox and user OS color scheme preference
const $e68b6f26e5e2e4f1$var$darkModeSwitch = document.querySelector(".theme-switch");
const $e68b6f26e5e2e4f1$var$checkbox = $e68b6f26e5e2e4f1$var$darkModeSwitch.querySelector(".switch__checkbox");
//* all the single elements classes needed to apply dark mode
const $e68b6f26e5e2e4f1$var$singleElementsClasses = [
    "feedback-message",
    "header__title",
    "keyboard",
    "theme-switch"
];
//* all the multiple elements classes needed to apply dark mode
// elements that needs one hyphen (-dark) to apply dark mode 
const $e68b6f26e5e2e4f1$var$singleHyphenElements = [
    "game-board__letter--missing",
    "game-board__letter--close",
    "game-board__letter--correct",
    "keyboard__letter--missing",
    "keyboard__letter--close",
    "keyboard__letter--correct",
    "fake-letter--missing",
    "fake-letter--close",
    "fake-letter--correct"
];
// elements that needs two hyphen (--dark) to apply dark mode 
const $e68b6f26e5e2e4f1$var$doubleHyphenElements = [
    "game-board__letter",
    "keyboard__letter",
    "row-separator",
    "fake-letter",
    "subheader-text",
    "how-to-play__headings",
    "how-to-play__list",
    "loading-container",
    "loading-spinner",
    "source-notice"
];
const $e68b6f26e5e2e4f1$var$multipleElementsClasses = [
    $e68b6f26e5e2e4f1$var$singleHyphenElements,
    $e68b6f26e5e2e4f1$var$doubleHyphenElements
];
// light and dark theme SVG elements
const $e68b6f26e5e2e4f1$var$lightThemeSVGs = document.body.querySelectorAll(".light-theme__svg");
const $e68b6f26e5e2e4f1$var$darkThemeSVGs = document.body.querySelectorAll(".dark-theme__svg");
//**********************************
//* General dialog Functions
//**********************************/
function $e68b6f26e5e2e4f1$var$openDialog(dialogName) {
    if (dialogName === "settings") {
        // add dialog entry animation
        (0, $f8d8239ac9be2ae9$export$21d6af064bc42dba)($e68b6f26e5e2e4f1$var$settingsDialog);
        // show dialog and give focus to it
        $e68b6f26e5e2e4f1$var$settingsDialog.showModal();
        $e68b6f26e5e2e4f1$var$settingsDialog.focus();
    } else if (dialogName === "howToPlay") {
        (0, $f8d8239ac9be2ae9$export$21d6af064bc42dba)($e68b6f26e5e2e4f1$var$howToPlayDialog);
        $e68b6f26e5e2e4f1$var$howToPlayDialog.showModal();
        $e68b6f26e5e2e4f1$var$howToPlayDialog.focus();
    }
    // add an event listener on page for the ESC key and outside the modal box clicks
    document.addEventListener("keydown", $e68b6f26e5e2e4f1$var$handleEscKeyClick(dialogName));
    document.addEventListener("click", $e68b6f26e5e2e4f1$var$handleOutsideDialogClick(dialogName));
    if (!(0, $1cc9319a0b1861d3$export$af20da7343c4b20b).isSolved) // remove user input event listeners to prevent interaction
    (0, $d564d07d12776a5d$export$7da0d8f971993eb)();
}
function $e68b6f26e5e2e4f1$var$closeDialog(dialogName) {
    if (dialogName === "settings") {
        // Get corresponding dialog button
        const settingsBtn = document.body.querySelector(".settings-btn");
        // add dialog exit animation
        (0, $f8d8239ac9be2ae9$export$48363b365af47301)($e68b6f26e5e2e4f1$var$settingsDialog);
        setTimeout(()=>{
            // close dialog after animation duration and blur away from the button
            $e68b6f26e5e2e4f1$var$settingsDialog.close();
            settingsBtn.blur();
        }, 450);
    } else if (dialogName === "howToPlay") {
        const howToPlayBtn = document.body.querySelector(".how-to-play-btn");
        // add dialog exit animation
        (0, $f8d8239ac9be2ae9$export$48363b365af47301)($e68b6f26e5e2e4f1$var$howToPlayDialog);
        // close dialog after animation duration
        setTimeout(()=>{
            $e68b6f26e5e2e4f1$var$howToPlayDialog.close();
            howToPlayBtn.blur();
        }, 450);
    }
    // remove both dialog related event listeners
    document.removeEventListener("keydown", $e68b6f26e5e2e4f1$var$EscKeyDialogEvent);
    document.removeEventListener("click", $e68b6f26e5e2e4f1$var$outsideDialogAreaEvent);
    if (!(0, $1cc9319a0b1861d3$export$af20da7343c4b20b).isSolved) // add user input event listeners to regain interactivity
    (0, $d564d07d12776a5d$export$9bcec1d37b9fc29c)();
}
/*
  * this function handles the press of an ESC key if a dialog is opened
*/ // reference
let $e68b6f26e5e2e4f1$var$EscKeyDialogEvent;
function $e68b6f26e5e2e4f1$var$handleEscKeyClick(dialogName) {
    $e68b6f26e5e2e4f1$var$EscKeyDialogEvent = (ev)=>{
        if (ev.key === "Escape") {
            // prevent default behavior for ESC key with modal dialogs
            ev.preventDefault();
            // close the dialog
            $e68b6f26e5e2e4f1$var$closeDialog(dialogName);
        }
    };
    return $e68b6f26e5e2e4f1$var$EscKeyDialogEvent;
}
/*
  * this function handles mouse clicks outside of the dialog area
*/ // reference
let $e68b6f26e5e2e4f1$var$outsideDialogAreaEvent;
function $e68b6f26e5e2e4f1$var$handleOutsideDialogClick(dialogName) {
    $e68b6f26e5e2e4f1$var$outsideDialogAreaEvent = (ev)=>{
        if (ev.target instanceof HTMLDialogElement) $e68b6f26e5e2e4f1$var$closeDialog(dialogName);
    };
    return $e68b6f26e5e2e4f1$var$outsideDialogAreaEvent;
}
//**********************************
//* Settings dialog Functions
//**********************************/
function $e68b6f26e5e2e4f1$export$afc52e0074cd9f19() {
    const settingsBtn = document.querySelector(".settings-btn");
    const settingsCloseBtn = document.querySelector(".settings-close");
    settingsBtn.addEventListener("click", $e68b6f26e5e2e4f1$var$openSettingsEvent);
    settingsCloseBtn.addEventListener("click", $e68b6f26e5e2e4f1$var$closeSettingsEvent);
}
function $e68b6f26e5e2e4f1$var$openSettingsEvent() {
    $e68b6f26e5e2e4f1$var$openDialog("settings");
}
function $e68b6f26e5e2e4f1$var$closeSettingsEvent() {
    $e68b6f26e5e2e4f1$var$closeDialog("settings");
}
//**********************************
//* Dark mode Functions
//**********************************/
//*********************
//* Main Functions
//*********************/
//* initial check function to know if a switch to dark theme is needed based on user preference
function $e68b6f26e5e2e4f1$export$c4af5bec915d38ad() {
    // get current user preference
    let userPreference = $e68b6f26e5e2e4f1$var$detectPreferredColorScheme();
    if (userPreference === "dark") // switch to dark theme
    $e68b6f26e5e2e4f1$var$handleThemeChange();
}
//* main function for the dark mode button
function $e68b6f26e5e2e4f1$export$5dd67a880f168c58() {
    // add theme button event listener
    $e68b6f26e5e2e4f1$var$checkbox.addEventListener("click", $e68b6f26e5e2e4f1$var$handleThemeChange);
}
//*********************
//* Helper Functions
//*********************/
//* main event handler for the dark mode button
function $e68b6f26e5e2e4f1$var$handleThemeChange() {
    // get current theme
    let currentTheme = $e68b6f26e5e2e4f1$var$checkbox.getAttribute("data-theme");
    // get single elements with single class corresponding to them
    const singleElements = $e68b6f26e5e2e4f1$var$getSingleElements($e68b6f26e5e2e4f1$var$singleElementsClasses);
    // get multiple elements with single class corresponding to them
    const multipleElements = $e68b6f26e5e2e4f1$var$getMultipleElements($e68b6f26e5e2e4f1$var$multipleElementsClasses);
    // if current theme is light or on first theme change
    if (currentTheme === "light") // add dark mode classes
    $e68b6f26e5e2e4f1$var$addDarkTheme(singleElements, multipleElements);
    else // remove dark mode classes
    $e68b6f26e5e2e4f1$var$removeDarkTheme(singleElements, multipleElements);
}
//* detect user preferred color scheme
function $e68b6f26e5e2e4f1$var$detectPreferredColorScheme() {
    // on first session
    if (localStorage.getItem("themePreference") === null) {
        // get user preferred color scheme
        const prefersDark = window.matchMedia("(prefers-color-scheme: dark)").matches;
        // save user preference in local storage
        prefersDark ? localStorage.setItem("themePreference", "dark") : localStorage.setItem("themePreference", "light");
        // if dark is preferable, click the checkbox to apply visual changes to button
        if (prefersDark && $e68b6f26e5e2e4f1$var$checkbox.getAttribute("data-theme") === "light") $e68b6f26e5e2e4f1$var$checkbox.click();
        // return user preference
        return localStorage.getItem("themePreference");
    } else return localStorage.getItem("themePreference");
}
//* Dark mode applying function
function $e68b6f26e5e2e4f1$var$addDarkTheme(singleElements, multipleElements) {
    // change user preference in local storage to dark
    localStorage.setItem("themePreference", "dark");
    // change checkbox current theme attribute to dark
    $e68b6f26e5e2e4f1$var$checkbox.setAttribute("data-theme", "dark");
    // check the checkbox to apply visual changes => (handled with css)
    $e68b6f26e5e2e4f1$var$checkbox.checked = true;
    // handle SVG changes
    $e68b6f26e5e2e4f1$var$svgChanger($e68b6f26e5e2e4f1$var$lightThemeSVGs, $e68b6f26e5e2e4f1$var$darkThemeSVGs, "dark");
    // add theme to general elements
    const body = document.body;
    body.classList.add("body--dark");
    const header = document.body.querySelector("header");
    header.classList.add("header--dark");
    const dialogs = document.body.querySelectorAll("dialog");
    dialogs.forEach((dialog)=>{
        dialog.classList.add("dialog--dark");
    });
    // add dark mode to single elements using their class
    if (singleElements.length > 0) $e68b6f26e5e2e4f1$var$handleSingleElements(singleElements, "add");
    // add dark mode classes to each group of elements with a single class
    if (multipleElements.length > 0) $e68b6f26e5e2e4f1$var$handleMultipleElements(multipleElements, "add");
}
//* Dark mode removing function
function $e68b6f26e5e2e4f1$var$removeDarkTheme(singleElements, multipleElements) {
    // change user preference in local storage to light
    localStorage.setItem("themePreference", "light");
    // change checkbox current theme attribute to light
    $e68b6f26e5e2e4f1$var$checkbox.setAttribute("data-theme", "light");
    // handle SVG changes
    $e68b6f26e5e2e4f1$var$svgChanger($e68b6f26e5e2e4f1$var$lightThemeSVGs, $e68b6f26e5e2e4f1$var$darkThemeSVGs, "light");
    // remove theme from general elements
    const body = document.body;
    body.classList.remove("body--dark");
    const header = document.body.querySelector("header");
    header.classList.remove("header--dark");
    const dialogs = document.body.querySelectorAll("dialog");
    dialogs.forEach((dialog)=>{
        dialog.classList.remove("dialog--dark");
    });
    // remove dark mode from single elements using their class
    if (singleElements.length > 0) $e68b6f26e5e2e4f1$var$handleSingleElements(singleElements, "remove");
    // remove dark mode classes for each group of elements with a single class
    if (multipleElements.length > 0) $e68b6f26e5e2e4f1$var$handleMultipleElements(multipleElements, "remove");
}
/*
  * Function that takes an array of Elements from the DOM, and based on the method
  * either adds or removes dark mode classes based on the corresponding singleElementsClasses
*/ function $e68b6f26e5e2e4f1$var$handleSingleElements(elements, method) {
    elements.forEach((elem)=>{
        for (let elemClass of elem.classList)if ($e68b6f26e5e2e4f1$var$singleElementsClasses.includes(elemClass)) {
            if (method === "add") elem.classList.add(`${elemClass}--dark`);
            else if (method === "remove") elem.classList.remove(`${elemClass}--dark`);
        }
    });
}
/*
  * Function that takes an array of nodeLists from the DOM, and based on the method
  * either adds or removes dark mode classes based on the corresponding multipleElementsClasses
*/ function $e68b6f26e5e2e4f1$var$handleMultipleElements(elements, method) {
    elements.forEach((group)=>{
        // check it's not an empty nodeList
        if (group.length > 0) group.forEach((child)=>{
            /* 
          * for each element classList check for which classes he have from
          * the multipleElementsClasses array
        */ for (let elemClass of child.classList){
                // elements classes that needs one hyphen to apply dark mode classes
                const singleHyphenArr = $e68b6f26e5e2e4f1$var$multipleElementsClasses[0];
                // elements that needs two hyphens
                const doubleHyphenArr = $e68b6f26e5e2e4f1$var$multipleElementsClasses[1];
                if (singleHyphenArr.includes(elemClass)) {
                    if (method === "add") child.classList.add(`${elemClass}-dark`);
                    else if (method === "remove") child.classList.remove(`${elemClass}-dark`);
                } else if (doubleHyphenArr.includes(elemClass)) {
                    if (method === "add") child.classList.add(`${elemClass}--dark`);
                    else if (method === "remove") child.classList.remove(`${elemClass}--dark`);
                }
            }
        });
    });
}
/*
  * Function that takes as argument an array of class names which are associated with
  * only one element, and returns an array of elements from the DOM
*/ function $e68b6f26e5e2e4f1$var$getSingleElements(singleElementsClasses) {
    // initial array to store single elements
    let singleElements = [];
    // get elements
    singleElementsClasses.forEach((elem)=>{
        const element = $e68b6f26e5e2e4f1$var$getElement(elem);
        singleElements.push(element);
    });
    return singleElements;
}
/*
  * Function that takes as argument an array of class names which are associated with
  * multiple elements, and returns an array of nodeLists of elements from the DOM
*/ function $e68b6f26e5e2e4f1$var$getMultipleElements(multipleElementsClasses) {
    // initial array to store multiple elements
    let multipleElements = [];
    multipleElementsClasses.forEach((hyphenArr)=>{
        hyphenArr.forEach((group)=>{
            const elements = $e68b6f26e5e2e4f1$var$getElements(group);
            multipleElements.push(elements);
        });
    });
    return multipleElements;
}
// Function that takes a class name and returns one element from the DOM
function $e68b6f26e5e2e4f1$var$getElement(elementName) {
    return document.body.querySelector(`.${elementName}`);
}
//* Function that takes a class name and returns all associated elements from the DOM
function $e68b6f26e5e2e4f1$var$getElements(elementsName) {
    return document.body.querySelectorAll(`.${elementsName}`);
}
//* Function that handles SVG elements and changes them based on the current theme
function $e68b6f26e5e2e4f1$var$svgChanger(lightSVGs, darkSVGs, theme) {
    if (theme === "light") {
        lightSVGs.forEach((svg)=>{
            svg.removeAttribute("hidden");
        });
        darkSVGs.forEach((svg)=>{
            svg.setAttribute("hidden", "true");
        });
    } else if (theme === "dark") {
        darkSVGs.forEach((svg)=>{
            svg.removeAttribute("hidden");
        });
        lightSVGs.forEach((svg)=>{
            svg.setAttribute("hidden", "true");
        });
    }
}
//**********************************
//* how to play dialog Functions
//**********************************/
function $e68b6f26e5e2e4f1$export$d646718b184468fc() {
    const howToPlayBtn = document.body.querySelector(".how-to-play-btn");
    const howToPlayCloseBtn = document.body.querySelector(".how-to-play-close");
    howToPlayBtn.addEventListener("click", $e68b6f26e5e2e4f1$export$37507772aae22b47);
    howToPlayCloseBtn.addEventListener("click", $e68b6f26e5e2e4f1$var$closeHowToPlayDialog);
}
function $e68b6f26e5e2e4f1$export$37507772aae22b47() {
    // open how-to-play dialog
    $e68b6f26e5e2e4f1$var$openDialog("howToPlay");
    // get fake word row in the dialog
    const fakeWordRow = document.querySelector(".fake-game-row");
    const fakeWordCells = fakeWordRow.children;
    // animate the fake row when in viewport
    $e68b6f26e5e2e4f1$var$fakeRowObserver(fakeWordRow, fakeWordCells);
}
function $e68b6f26e5e2e4f1$var$closeHowToPlayDialog() {
    $e68b6f26e5e2e4f1$var$closeDialog("howToPlay");
}
/*
  * Function to observe if the fake word row in settings dialog is in viewport 
*/ function $e68b6f26e5e2e4f1$var$fakeRowObserver(fakeWordRow, fakeWordCells) {
    //* to avoid repeating animations if scrolled more than once
    let observationsLeft = 1;
    // the callback for observer
    function fakeRowCallback(entries) {
        entries.forEach((entry)=>{
            if (entry.isIntersecting && observationsLeft > 0) {
                observationsLeft--;
                (0, $f8d8239ac9be2ae9$export$8be79abfbbb1b7ab)(fakeWordCells);
            }
        });
    }
    // observer options
    const intersectionOptions = {
        root: null,
        rootMargin: "0px",
        threshold: 1
    };
    // create a new observer
    const observer = new IntersectionObserver(fakeRowCallback, intersectionOptions);
    // observe the fake row
    observer.observe(fakeWordRow);
}




//********************* */
//* Global Variables
//********************* */
// keyboardElement And keyboard buttons
const $d564d07d12776a5d$var$keyboardContainer = document.querySelector(".keyboard");
const $d564d07d12776a5d$var$keyboardBtns = document.querySelectorAll(".keyboard__letter");
// row cells first change state
let $d564d07d12776a5d$var$cellsChanged = false;
//****************************************************** */
//* Main Functions
//****************************************************** */
/*
  * Double Functions which switches application's functionality on and off
*/ function $d564d07d12776a5d$export$9bcec1d37b9fc29c() {
    $d564d07d12776a5d$var$handleKeyDown();
    $d564d07d12776a5d$var$handleKeyupEvent();
    $d564d07d12776a5d$var$handleKeyboardClicks();
}
function $d564d07d12776a5d$export$7da0d8f971993eb() {
    document.body.removeEventListener("keydown", $d564d07d12776a5d$var$onKeyDownEvent);
    document.body.removeEventListener("keyup", $d564d07d12776a5d$var$onKeyUp);
    $d564d07d12776a5d$var$keyboardContainer.removeEventListener("click", $d564d07d12776a5d$var$keyboardClickEvent);
}
/*
  * function that handles all buttons events in the app
*/ function $d564d07d12776a5d$export$cfb94089535b8ca7() {
    (0, $e68b6f26e5e2e4f1$export$afc52e0074cd9f19)();
    (0, $e68b6f26e5e2e4f1$export$5dd67a880f168c58)();
    (0, $e68b6f26e5e2e4f1$export$d646718b184468fc)();
}
//****************************************************** */
//* Helper Functions
//****************************************************** */
async function $d564d07d12776a5d$var$handleKeyDown() {
    // get current word of the day
    const wordOfTheDay = await (0, $d6cfc0aabef0aa82$export$a5bfddfac516cc04)();
    document.body.addEventListener("keydown", $d564d07d12776a5d$var$onKeyDown(wordOfTheDay));
}
// reference to keyDown event function
let $d564d07d12776a5d$var$onKeyDownEvent;
function $d564d07d12776a5d$var$onKeyDown(wordOfTheDay) {
    $d564d07d12776a5d$var$onKeyDownEvent = function onKeyDownEvent(ev) {
        if ((0, $1cc9319a0b1861d3$export$7abfd4649f15e11f).currentRow < 6) {
            // current active gameBoard row
            const rowCells = document.querySelectorAll(".game-board__row")[(0, $1cc9319a0b1861d3$export$7abfd4649f15e11f).currentRow].children;
            // pressed key value
            const key = ev.key;
            // check if gameBoard values has been changed
            $d564d07d12776a5d$var$cellsChanged = (0, $5ab19e18f0cc9b1e$export$412508d679148d5c)(rowCells, key);
            if ($d564d07d12776a5d$var$cellsChanged) {
                /*
          * handle cells adding animation only here
            ** backspace animation is handled in the handleInput function
            ** enter animation is handled in the enter block (completeValidationCheck)
        */ if (key !== "Backspace" && key !== "Enter") (0, $f8d8239ac9be2ae9$export$2b30b4c5c46f02b8)(rowCells, key);
                // handle enter key animation in the enter validation block
                if (key !== "Enter") (0, $f8d8239ac9be2ae9$export$5c4515537cbee0e0)($d564d07d12776a5d$var$keyboardBtns, key);
                // if validation
                if (key === "Enter") {
                    // check the current focused element
                    const currentFocusedElement = document.activeElement;
                    // apply only if the focused element is the body or the Enter button
                    if (currentFocusedElement instanceof HTMLBodyElement || currentFocusedElement.classList.contains(".enter-button")) {
                        // handle enter keyboard animation
                        (0, $f8d8239ac9be2ae9$export$5c4515537cbee0e0)($d564d07d12776a5d$var$keyboardBtns, key);
                        // do a complete validation check
                        (0, $50a8fd1ed092fc9a$export$e41ca8f156de93e6)(rowCells, $d564d07d12776a5d$var$keyboardBtns, wordOfTheDay);
                    }
                }
            }
        }
    };
    return $d564d07d12776a5d$var$onKeyDownEvent;
}
function $d564d07d12776a5d$var$handleKeyupEvent() {
    // releasing user keyboard buttons event
    document.body.addEventListener("keyup", $d564d07d12776a5d$var$onKeyUp);
}
function $d564d07d12776a5d$var$onKeyUp(ev) {
    const key = ev.key;
    (0, $f8d8239ac9be2ae9$export$82f1d4313688e804)($d564d07d12776a5d$var$keyboardBtns, key);
}
async function $d564d07d12776a5d$var$handleKeyboardClicks() {
    const wordOfTheDay = await (0, $d6cfc0aabef0aa82$export$a5bfddfac516cc04)();
    $d564d07d12776a5d$var$keyboardContainer.addEventListener("click", $d564d07d12776a5d$var$onKeyboardClick(wordOfTheDay));
}
// reference to the event function (for removal purposes)
let $d564d07d12776a5d$var$keyboardClickEvent;
function $d564d07d12776a5d$var$onKeyboardClick(wordOfTheDay) {
    // store function
    $d564d07d12776a5d$var$keyboardClickEvent = function keyboardClickEvent(ev) {
        if ((0, $1cc9319a0b1861d3$export$7abfd4649f15e11f).currentRow < 6) {
            // current active gameBoard row
            const rowCells = document.querySelector(".game-board__row[data-state='TBD']").children;
            // current clicked button
            const clickedButton = ev.target;
            // if not a button
            if (!(clickedButton instanceof HTMLButtonElement || clickedButton instanceof HTMLImageElement)) return;
            if (clickedButton instanceof HTMLImageElement || clickedButton.classList.contains("backspace-button")) $d564d07d12776a5d$var$cellsChanged = (0, $5ab19e18f0cc9b1e$export$412508d679148d5c)(rowCells, "Backspace");
            else if (clickedButton.classList.contains("enter-button")) {
                $d564d07d12776a5d$var$cellsChanged = (0, $5ab19e18f0cc9b1e$export$412508d679148d5c)(rowCells, "Enter");
                // do a complete validation check
                (0, $50a8fd1ed092fc9a$export$e41ca8f156de93e6)(rowCells, $d564d07d12776a5d$var$keyboardBtns, wordOfTheDay);
            } else {
                $d564d07d12776a5d$var$cellsChanged = (0, $5ab19e18f0cc9b1e$export$412508d679148d5c)(rowCells, clickedButton.innerHTML);
                if ($d564d07d12776a5d$var$cellsChanged) (0, $f8d8239ac9be2ae9$export$2b30b4c5c46f02b8)(rowCells, clickedButton.innerHTML);
            }
            // deFocus from the clicked button
            clickedButton.blur();
        }
    };
    // return to the currying function
    return $d564d07d12776a5d$var$keyboardClickEvent;
}




//********************* */
//* Global Variables
//********************* */
// track on screen feedback
let $50a8fd1ed092fc9a$var$feedbackOnScreen = false;
//****************************************************** */
//* Main Functions
//****************************************************** */
/*
  * Function to display feedback messages on screen
  * message => the message displayed in the feedback element
  * stayOnScreen => boolean indicating whether the feedback will stay on screen or not
  * timeOnScreen => only needed if stayOnScreen is false, to represent the time on screen in seconds before removal
*/ function $50a8fd1ed092fc9a$export$6ec214f034b61612(message, stayOnScreen, timeOnScreen) {
    const feedbackElement = document.querySelector(".feedback-message");
    feedbackElement.innerHTML = `${message}`;
    if (!$50a8fd1ed092fc9a$var$feedbackOnScreen) $50a8fd1ed092fc9a$var$displayFeedback(feedbackElement, stayOnScreen, timeOnScreen);
}
/*
  * the main Function to handle the full process of validating
    ** Checks if row is complete
    ** assembles the word if complete, otherwise does the corresponding animation
    ** handleValidation => returns false => if word is invalid or on server error
    ** => returns an array of boolean and string values indicating similarity between the two words
    ** handle related animations based on handleValidation return value
    ** in case of a successful validation check, Save game state and check if it's "game over"
*/ async function $50a8fd1ed092fc9a$export$e41ca8f156de93e6(rowCells, keyboardBtns, wordOfTheDay) {
    // check for row completeness
    let rowComplete = $50a8fd1ed092fc9a$var$rowCheck(rowCells);
    if (rowComplete) {
        // show loading indicator
        (0, $f8d8239ac9be2ae9$export$64858b67578a10bb)();
        // get user input and handle validation and animation
        const userInput = $50a8fd1ed092fc9a$var$assembleWord(rowCells);
        const similarLetters = await $50a8fd1ed092fc9a$var$handleValidation(wordOfTheDay, userInput, rowCells, keyboardBtns);
        // hide loading indicator
        (0, $f8d8239ac9be2ae9$export$7d026bf51c574e0d)();
        if (similarLetters === false) // do invalid word animation
        (0, $f8d8239ac9be2ae9$export$2b30b4c5c46f02b8)(rowCells, "enter");
        else {
            // Animate changes to row cells and keyboard buttons based on their similarity
            (0, $f8d8239ac9be2ae9$export$2b30b4c5c46f02b8)(rowCells, "enter", similarLetters, keyboardBtns);
            // Mark row as completed
            document.querySelectorAll(".game-board__row")[(0, $1cc9319a0b1861d3$export$7abfd4649f15e11f).currentRow].dataset.state = "DONE";
            // save current game state after animations durations has completed
            setTimeout(()=>{
                (0, $1cc9319a0b1861d3$export$384cd953322e3851)(rowCells);
            }, 1200);
        }
        // check if game ended
        if (similarLetters !== false) $50a8fd1ed092fc9a$var$endGameCheck();
    }
}
//****************************************************** */
//* Helper Functions
//****************************************************** */
/*
  * function that displays feedback on the screen
  * elem => takes the feedback element as a first argument
  * stayOnScreen => boolean indicating whether the feedback will stay on screen or not
  * timeInSeconds => elapsed time for each feedback message
*/ function $50a8fd1ed092fc9a$var$displayFeedback(elem, stayOnScreen, timeInSeconds) {
    // add entry animation
    elem.classList.add("fade-in-feedback");
    $50a8fd1ed092fc9a$var$feedbackOnScreen = true;
    if (!stayOnScreen) {
        // remove entry animation, apply and remove exit animation
        setTimeout(()=>{
            elem.classList.remove("fade-in-feedback");
            elem.classList.add("fade-out-feedback");
        }, timeInSeconds * 1000);
        setTimeout(()=>{
            elem.classList.remove("fade-out-feedback");
            $50a8fd1ed092fc9a$var$feedbackOnScreen = false;
        }, timeInSeconds * 1000 + 500);
    }
}
//* Function that checks if row cells are complete
function $50a8fd1ed092fc9a$var$rowCheck(rowCells) {
    let rowComplete = false;
    for(let i = 0; i < rowCells.length; i++)if (rowCells[i].innerText === "") {
        // Give feedback to the user
        $50a8fd1ed092fc9a$export$6ec214f034b61612("Not Enough Letters", false, 1);
        // do rejection animation
        (0, $f8d8239ac9be2ae9$export$2b30b4c5c46f02b8)(rowCells, "enter");
        rowComplete = false;
        break;
    } else rowComplete = true;
    return rowComplete;
}
//* Connect row letters into a word
function $50a8fd1ed092fc9a$var$assembleWord(rowCells) {
    let string = "";
    for (let cell of rowCells)string += cell.textContent;
    return string;
}
/*
  * handleValidation returns:
  * false => in case of invalid user input
  * Array that represents similarity between userInput and word of the day
  * based on index of characters => in case of a valid user input
*/ async function $50a8fd1ed092fc9a$var$handleValidation(wordOfTheDay, userInput) {
    // if there is no word of the day (i.e Fetch Failed)
    if (wordOfTheDay === undefined) return false;
    // Get similar letters between user input and word of the day
    const similarLetters = await $50a8fd1ed092fc9a$var$compareWords(wordOfTheDay, userInput);
    // if user input is invalid
    if (similarLetters === false) return false;
    else {
        // check if word is solved
        for (let letter of similarLetters)if (letter === true) (0, $1cc9319a0b1861d3$export$7abfd4649f15e11f).isSolved = true;
        else {
            (0, $1cc9319a0b1861d3$export$7abfd4649f15e11f).isSolved = false;
            break;
        }
        if ((0, $1cc9319a0b1861d3$export$7abfd4649f15e11f).isSolved) {
            const winFeedbackTime = 2.5;
            switch((0, $1cc9319a0b1861d3$export$7abfd4649f15e11f).currentRow){
                case 0:
                    $50a8fd1ed092fc9a$export$6ec214f034b61612("Exceptional", false, winFeedbackTime);
                    break;
                case 1:
                    $50a8fd1ed092fc9a$export$6ec214f034b61612("Incredible", false, winFeedbackTime);
                    break;
                case 2:
                    $50a8fd1ed092fc9a$export$6ec214f034b61612("Impressive", false, winFeedbackTime);
                    break;
                case 3:
                    $50a8fd1ed092fc9a$export$6ec214f034b61612("Great", false, winFeedbackTime);
                    break;
                case 4:
                    $50a8fd1ed092fc9a$export$6ec214f034b61612("Nice", false, winFeedbackTime);
                    break;
                default:
                    $50a8fd1ed092fc9a$export$6ec214f034b61612("Phew", false, winFeedbackTime);
            }
        } else if ((0, $1cc9319a0b1861d3$export$7abfd4649f15e11f).currentRow === 5) $50a8fd1ed092fc9a$export$6ec214f034b61612(`Correct word: ${wordOfTheDay.toUpperCase()}`, true);
        // return similarLetters
        return similarLetters;
    }
}
/*
  * This function compares both words (word of the day , user input) for similarity
  * returns false and displays feedback => if user input is an invalid word
  * returns false only => 
    ** if the isWord function returns undefined 
    ** if the words are not equal in length or the word of the day has any invalid characters
  
  * returns a mixed array of booleans and strings => in case of a valid check
  * with the three values:
    ** true => for characters available in both words at the same position
    ** "close" => for characters available in both words at different positions
    ** false => for characters missing from one word compared to the other
*/ async function $50a8fd1ed092fc9a$var$compareWords(wordOfTheDay, userInput) {
    // check if user input is a valid word
    const validWord = await $50a8fd1ed092fc9a$var$isWord(userInput);
    // if invalid word
    if (validWord === false) {
        $50a8fd1ed092fc9a$export$6ec214f034b61612("Not In Word List", false, 1.5);
        return false;
    } else if (validWord === undefined) return false;
    // check words lengths
    if (/\d/.test(wordOfTheDay) || wordOfTheDay.length !== userInput.length) {
        $50a8fd1ed092fc9a$export$6ec214f034b61612("Server Error, Enjoy a cookie while we work on it \uD83D\uDE19", true);
        return false;
    }
    // initial similarity between user input and word of the day
    let similarLetters = Array.from(userInput, ()=>false);
    // unify input
    wordOfTheDay = wordOfTheDay.toLowerCase();
    userInput = userInput.toLowerCase();
    // check for similarity between letters
    for(let i = 0; i < wordOfTheDay.length; i++){
        // find indices of letters in userInput that are the same as current word of the day letter
        let foundIndices = $50a8fd1ed092fc9a$var$findLetterIndices(userInput, wordOfTheDay[i]);
        // if word of the day letter is found only once in user input
        if (foundIndices.length === 1) $50a8fd1ed092fc9a$var$handleSingleOccurrence(foundIndices[0], i, similarLetters);
        else $50a8fd1ed092fc9a$var$handleMultipleOccurrences(foundIndices, i, similarLetters);
    }
    return similarLetters;
}
/*
  * This function returns an array of all found indices for the second argument (letter)
  * inside of the first argument (word)
*/ function $50a8fd1ed092fc9a$var$findLetterIndices(userInputWord, wordOfTheDayLetter) {
    // initial array to track all found indices
    let foundIndices = [];
    // check for first occurrence of word of the day letter in the user input
    let currentFound = userInputWord.indexOf(wordOfTheDayLetter);
    // check for any subsequent occurrences
    while(currentFound !== -1){
        // push the first found occurrence
        foundIndices.push(currentFound);
        // look for further indices following the last occurrence
        currentFound = userInputWord.indexOf(wordOfTheDayLetter, currentFound + 1);
    }
    return foundIndices;
}
//* This function handles single letter occurrence in wordOfTheDay
function $50a8fd1ed092fc9a$var$handleSingleOccurrence(foundIndex, currentIndex, similarLetters) {
    if (foundIndex === currentIndex) similarLetters[foundIndex] = true;
    else if (similarLetters[foundIndex] === false) similarLetters[foundIndex] = "close";
}
//* This function handles multiple letter occurrences in wordOfTheDay
function $50a8fd1ed092fc9a$var$handleMultipleOccurrences(foundIndices, todayWordLetterIndex, similarLetters) {
    /*
    * initial differences between userInput Indices and current word of the day letter
      ** for example: if found index is 1 and word of the day letter index is 4 => difference is 3
      ** map key => found index
      ** map key value => indices difference
  */ let indicesDifferences = new Map();
    // get Indices differences
    foundIndices.forEach((foundIndex)=>{
        const foundIndexDifference = Math.abs(foundIndex - todayWordLetterIndex);
        indicesDifferences.set(`${foundIndex}`, foundIndexDifference);
    });
    // find closest found index to word of the day letter
    let closestIndex = $50a8fd1ed092fc9a$var$findClosestIndex(indicesDifferences);
    // remove entry (to avoid including in future searches)
    indicesDifferences.delete(closestIndex);
    if (Number(closestIndex) === todayWordLetterIndex) similarLetters[closestIndex] = true;
    else // if hasn't been processed yet
    if (similarLetters[closestIndex] === false) // mark as close
    similarLetters[closestIndex] = "close";
    else // look for the next closest index that hasn't been processed
    $50a8fd1ed092fc9a$var$handleRemainingDifferences(indicesDifferences, similarLetters);
}
//* This function return the first index with the lowest difference
function $50a8fd1ed092fc9a$var$findClosestIndex(differencesMap) {
    // Get closest Index based on smallest difference
    let minEntry = [
        ...differencesMap.entries()
    ].reduce((arr, [index, diff])=>{
        return diff < arr[1] ? [
            index,
            diff
        ] : arr;
    }, [
        null,
        Infinity
    ]);
    return minEntry[0];
}
/*
  * This function checks for an unprocessed subsequent letter index
  * either handling it (if found) or exhausting and nulling the differences Map
*/ function $50a8fd1ed092fc9a$var$handleRemainingDifferences(differencesMap, similarLetters) {
    while(differencesMap.size > 0){
        // find closest index and delete from future searches
        let closestIndex = $50a8fd1ed092fc9a$var$findClosestIndex(differencesMap);
        differencesMap.delete(closestIndex);
        // if an unprocessed index is found, handle and break out of loop
        if (similarLetters[closestIndex] === false) {
            similarLetters[closestIndex] = "close";
            break;
        }
    }
}
/*
  * This function check if the user input is a valid word
    ** returns true => in case of a valid word
    ** returns false => in case of an invalid word
    ** returns undefined => if there is no internet or on API server errors
*/ async function $50a8fd1ed092fc9a$var$isWord(word) {
    // Post to validation API
    const request = await fetch("https://words.dev-apis.com/validate-word", {
        method: "POST",
        body: JSON.stringify({
            "word": `${word}`
        }),
        headers: {
            "Content-Type": "application/json",
            "Connection": "keep-alive"
        }
    }).catch(()=>{
        $50a8fd1ed092fc9a$export$6ec214f034b61612("Server Error, please check your internet connection \uD83D\uDE1E", false, 3);
    });
    if (request === undefined) return undefined;
    // Get Response Object
    const responseObject = await request.json();
    return responseObject.validWord;
}
/*
  *  Function to check if the word has been solved
    ** removes functionality => if word has been solved
    ** switches to next row => if current row is not last row
*/ function $50a8fd1ed092fc9a$var$endGameCheck() {
    // update the row
    if ((0, $1cc9319a0b1861d3$export$7abfd4649f15e11f).isSolved) (0, $d564d07d12776a5d$export$7da0d8f971993eb)();
    else if ((0, $1cc9319a0b1861d3$export$7abfd4649f15e11f).currentRow < 6) // increment to next row after animations durations has completed
    setTimeout(()=>{
        (0, $1cc9319a0b1861d3$export$7abfd4649f15e11f).currentRow++;
    }, 1200);
}



//********************* */
//* Main Functions
//********************* */
/*
  * The main function for fetching word of the day
    ** if first session or first fetch of the day => returns the word from the API
    ** otherwise => returns the word from local storage
*/ async function $d6cfc0aabef0aa82$export$a5bfddfac516cc04() {
    // check if a day has passed since the last session
    const isNewDay = $d6cfc0aabef0aa82$export$c3e675fb255e6adf();
    // if first user session or a day has passed
    if (localStorage.getItem("wordOfTheDay") === null || isNewDay) // initialize a new word in local storage and return it
    return await $d6cfc0aabef0aa82$var$initNewWord();
    else return $d6cfc0aabef0aa82$var$decodeWord(localStorage.getItem("wordOfTheDay"));
}
/*
  * This function compares current day vs day saved in local storage
    ** true => if first user session or a day has passed
    ** false => if still the same day
*/ function $d6cfc0aabef0aa82$export$c3e675fb255e6adf() {
    // if first user session
    const firstSession = $d6cfc0aabef0aa82$var$isDayNotFound();
    if (firstSession) {
        // set new date key
        $d6cfc0aabef0aa82$export$a3ec1d5da0d8ff59();
        // open how to play dialog
        $d6cfc0aabef0aa82$var$delayedHowToPlayOpen();
        // return that a day has passed
        return true;
    } else {
        const todayDate = $d6cfc0aabef0aa82$var$getTodayDate();
        // compare current day against localStorage saved day
        return todayDate !== localStorage.getItem("currentDay");
    }
}
//********************* */
//* Helper Functions
//********************* */
//* Function to get a new word from the API
async function $d6cfc0aabef0aa82$var$initNewWord() {
    // get new word
    const wordOfTheDay = await $d6cfc0aabef0aa82$var$requestWordOfTheDay();
    // encode and store in local storage
    localStorage.setItem("wordOfTheDay", $d6cfc0aabef0aa82$var$encodeWord(wordOfTheDay));
    return wordOfTheDay;
}
//* Function to handle Promise resolution or rejection when fetching a new word
async function $d6cfc0aabef0aa82$var$requestWordOfTheDay() {
    const promise = fetch("https://words.dev-apis.com/word-of-the-day");
    return promise.then((response)=>response.json()).then((responseObject)=>responseObject.word).catch(()=>{
        (0, $50a8fd1ed092fc9a$export$6ec214f034b61612)(`Server error 😐`, false);
    });
}
//* get current day as a string "day/month/year" relative to GMT+0000 (UTC) => reset time for word of the day
function $d6cfc0aabef0aa82$var$getTodayDate() {
    const currentDate = new Date();
    const currentDay = `${currentDate.getUTCDate()}/${currentDate.getUTCMonth() + 1}/${currentDate.getUTCFullYear()}`;
    return currentDay;
}
//* Function to set a new date
function $d6cfc0aabef0aa82$export$a3ec1d5da0d8ff59() {
    localStorage.setItem("currentDay", $d6cfc0aabef0aa82$var$getTodayDate());
}
//* Function to remove the current date from the local storage
function $d6cfc0aabef0aa82$export$5f9ade464756e316() {
    localStorage.removeItem("currentDay");
}
/*
  * Function to check if a day key does not exist in localStorage
  * if not found => return true
  * otherwise => return false
*/ function $d6cfc0aabef0aa82$var$isDayNotFound() {
    if (localStorage.getItem("currentDay") === null) return true;
    else return false;
}
/*
  * This is a function that delays the opening of how to play dialog
  * based on network speed
*/ async function $d6cfc0aabef0aa82$var$delayedHowToPlayOpen() {
    // calculate network speed based on how fast word of the day is fetched
    const startTime = performance.now();
    // get today word and save it in local storage
    await $d6cfc0aabef0aa82$export$a5bfddfac516cc04();
    const endTime = performance.now();
    const timeTaken = endTime - startTime;
    /*
    *  the main function execution time in seconds
      ** after some testing, this is roughly the JS execution time
      ** based on network speed alone (not device processing power)
      
    * safety delay is also arbitrarily set after some network speed testing
  */ const jsExecutionTime = timeTaken * 2;
    const additionalSafetyDelay = 500;
    //* delay dialog opening based on network speed
    await new Promise((resolve)=>setTimeout(resolve, jsExecutionTime + additionalSafetyDelay));
    (0, $e68b6f26e5e2e4f1$export$37507772aae22b47)();
}
//* Function to scramble word of the day before storing it in the local storage
function $d6cfc0aabef0aa82$var$encodeWord(word) {
    // fake array to add additional characters from to the encoded string
    const fakeHashArr = [
        "!",
        "$",
        "7",
        "&",
        "?",
        "p",
        "q",
        "r",
        "/",
        "<",
        "g",
        ".",
        "5",
        "i",
        " ",
        "9",
        "4",
        "-",
        ")",
        "D",
        "T",
        "R",
        "{",
        "}",
        "U",
        "Z",
        "t",
        "K",
        "P",
        "~",
        ";",
        "|",
        ":",
        "z",
        "V",
        "W",
        "X",
        "+",
        "=",
        "G",
        "H",
        "I",
        "@",
        "#",
        "%",
        "3",
        ">",
        "^",
        "c",
        "d"
    ];
    const hashArrLen = fakeHashArr.length;
    // initial value for number of letters in encoded word to each letter from original
    let addedCharsForLetter = 26;
    // the index at which resides the real letter
    const OriginalLetterIndex = 11;
    let encodedWord = "";
    // for each letter
    for (let letter of word){
        // add the additional characters
        for(let i = 0; i < addedCharsForLetter; i++)if (i === OriginalLetterIndex) encodedWord += String.fromCharCode(letter.charCodeAt(0) - 64);
        else encodedWord += fakeHashArr[parseInt(Math.random() * 100) % hashArrLen];
        // arbitrarily increment added chars for next letters
        addedCharsForLetter += 17;
    }
    return encodedWord;
}
//* Function to unscramble word of the day before retrieving it from the local storage
function $d6cfc0aabef0aa82$var$decodeWord(encodedWord) {
    // initial variables
    let addedCharsForLetter = 26;
    const OriginalLetterIndex = 11;
    let decodedWord = "";
    // array to store each chunk in encodedWord holding a letter
    let letters = [];
    // split encoded word until zero letters in length
    while(encodedWord !== ""){
        letters.push(encodedWord.substring(0, addedCharsForLetter));
        encodedWord = encodedWord.slice(addedCharsForLetter);
        addedCharsForLetter += 17;
    }
    // add only from the encoding key index
    for (let letter of letters)decodedWord += String.fromCharCode(letter[OriginalLetterIndex].charCodeAt(0) + 64);
    return decodedWord;
}





function $bc7cbdf963c5cf2d$var$main() {
    // check if it's a new day
    const isNewDay = (0, $d6cfc0aabef0aa82$export$c3e675fb255e6adf)();
    // if there is a saved game state and a day hasn't passed yet
    if ((0, $1cc9319a0b1861d3$export$af20da7343c4b20b).currentRow !== -1 && !isNewDay) (0, $1cc9319a0b1861d3$export$70a369479cdf5432)((0, $1cc9319a0b1861d3$export$af20da7343c4b20b));
    // do an initial dark mode check
    (0, $e68b6f26e5e2e4f1$export$c4af5bec915d38ad)();
    // add input functionality if word hasn't been solved yet for the current day
    if (!(0, $1cc9319a0b1861d3$export$af20da7343c4b20b).isSolved) (0, $d564d07d12776a5d$export$9bcec1d37b9fc29c)();
    // add buttons event handlers
    (0, $d564d07d12776a5d$export$cfb94089535b8ca7)();
    // update day if it's a new day
    if (isNewDay) {
        // remove previous date from local storage
        (0, $d6cfc0aabef0aa82$export$5f9ade464756e316)();
        // add the new one
        (0, $d6cfc0aabef0aa82$export$a3ec1d5da0d8ff59)();
    }
}
$bc7cbdf963c5cf2d$var$main();


//# sourceMappingURL=index.1cafa8c4.js.map
